import { render, staticRenderFns } from "./QualityResultList.vue?vue&type=template&id=37a35982&"
import script from "./QualityResultList.vue?vue&type=script&lang=js&"
export * from "./QualityResultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports